import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LogsData } from 'src/app/model/LogsData';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { environment } from 'src/environments/environment';
import * as Parse from 'parse';

export interface ActivityPlanHistoryData {
  activity: string;
  minutes: string;
  day: string;
  status: string;
}

@Component({
  selector: 'app-activityplan-history',
  templateUrl: './activityplan-history.component.html',
  styleUrls: ['./activityplan-history.component.css']
})
export class ActivityplanHistoryComponent implements OnInit {

  displayedColumns: string[] = ['activity', 'minutes', 'day', 'status'];
  dataSource = new MatTableDataSource<ActivityPlanHistoryData>();
  data: LogsData[];
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
  );
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private _bkoffService: BackOffServiceService
  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }

  ngOnInit() {
    var DATA : ActivityPlanHistoryData[] = [];

    this._bkoffService.getPastActivityPlanHistory().then((res) => {
      this.data = res;
      this.data.forEach(element => {
        DATA.push({activity: element.planactivity,
                   minutes: element.planminutes,
                   day: element.activitydays,
                   status: element.activityStatus});
      });  
      this.dataSource = new MatTableDataSource<ActivityPlanHistoryData>(DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });

  }

}
